/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LayoutImport } from './routes/_layout'
import { Route as commonSetUpPasswordImport } from './routes/(common)/set-up-password'
import { Route as commonResetPasswordImport } from './routes/(common)/reset-password'
import { Route as commonLoginImport } from './routes/(common)/login'
import { Route as LayoutTenantIssuesIndexImport } from './routes/_layout/tenant/issues/index'
import { Route as LayoutTenantBookingRulesIndexImport } from './routes/_layout/tenant/booking-rules/index'
import { Route as LayoutTenantSpacesLayoutImport } from './routes/_layout/tenant/spaces/_layout'
import { Route as LayoutTenantOrganizationDetailsLayoutImport } from './routes/_layout/tenant/organization-details/_layout'
import { Route as LayoutTenantEmployeesLayoutImport } from './routes/_layout/tenant/employees/_layout'
import { Route as LayoutTenantBookingsLayoutImport } from './routes/_layout/tenant/bookings/_layout'
import { Route as LayoutTenantStatisticsLayoutIndexImport } from './routes/_layout/tenant/statistics/_layout/index'
import { Route as LayoutTenantSpacesLayoutIndexImport } from './routes/_layout/tenant/spaces/_layout/index'
import { Route as LayoutTenantEmployeesLayoutIndexImport } from './routes/_layout/tenant/employees/_layout/index'
import { Route as LayoutTenantBookingsLayoutIndexImport } from './routes/_layout/tenant/bookings/_layout/index'
import { Route as LayoutTenantSpacesGroupsSpaceGroupTokenImport } from './routes/_layout/tenant/spaces/groups/$spaceGroupToken'
import { Route as LayoutTenantSpacesLayoutGroupsImport } from './routes/_layout/tenant/spaces/_layout/groups'
import { Route as LayoutTenantOrganizationDetailsLayoutAdminsImport } from './routes/_layout/tenant/organization-details/_layout/admins'
import { Route as LayoutTenantEmployeesLayoutGroupsImport } from './routes/_layout/tenant/employees/_layout/groups'
import { Route as LayoutTenantEmployeesGroupsGroupTokenLayoutImport } from './routes/_layout/tenant/employees/groups/$groupToken/_layout'
import { Route as LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsImport } from './routes/_layout/tenant/employees/groups/$groupToken/_layout/space-groups'
import { Route as LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesImport } from './routes/_layout/tenant/employees/groups/$groupToken/_layout/employees'
import { Route as LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsImport } from './routes/_layout/tenant/employees/groups/$groupToken/_layout/bookings'

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')()
const commonForgotPasswordLazyImport = createFileRoute(
  '/(common)/forgot-password',
)()
const LayoutTenantSpacesImport = createFileRoute('/_layout/tenant/spaces')()
const LayoutTenantOrganizationDetailsImport = createFileRoute(
  '/_layout/tenant/organization-details',
)()
const LayoutTenantEmployeesImport = createFileRoute(
  '/_layout/tenant/employees',
)()
const LayoutTenantBookingsImport = createFileRoute('/_layout/tenant/bookings')()
const LayoutTenantIndexLazyImport = createFileRoute('/_layout/tenant/')()
const LayoutSiteIndexLazyImport = createFileRoute('/_layout/site/')()
const LayoutTenantPasswordLazyImport = createFileRoute(
  '/_layout/tenant/password',
)()
const LayoutTenantAuditLogsLazyImport = createFileRoute(
  '/_layout/tenant/audit-logs',
)()
const commonTenantInvitationInvitationTokenLazyImport = createFileRoute(
  '/(common)/tenant-invitation_/$invitationToken',
)()
const LayoutTenantSpacesOldFloorPlannerLazyImport = createFileRoute(
  '/_layout/tenant/spaces/old-floor-planner',
)()
const LayoutTenantSpacesNewerOldFloorPlannerLazyImport = createFileRoute(
  '/_layout/tenant/spaces/newer-old-floor-planner',
)()
const LayoutTenantSpacesCreateLazyImport = createFileRoute(
  '/_layout/tenant/spaces/create',
)()
const LayoutTenantIssuesIssueTokenLazyImport = createFileRoute(
  '/_layout/tenant/issues/$issueToken',
)()
const LayoutTenantBookingsCreateLazyImport = createFileRoute(
  '/_layout/tenant/bookings/create',
)()
const LayoutTenantBookingRulesCreateLazyImport = createFileRoute(
  '/_layout/tenant/booking-rules/create',
)()
const LayoutTenantBookingRulesBookingRulesTokenLazyImport = createFileRoute(
  '/_layout/tenant/booking-rules/$bookingRulesToken',
)()
const LayoutTenantEmployeesGroupsGroupTokenImport = createFileRoute(
  '/_layout/tenant/employees/groups/$groupToken',
)()
const LayoutTenantOrganizationDetailsLayoutIndexLazyImport = createFileRoute(
  '/_layout/tenant/organization-details/_layout/',
)()
const LayoutTenantSpacesLayoutFloorPlannerLazyImport = createFileRoute(
  '/_layout/tenant/spaces/_layout/floor-planner',
)()
const LayoutTenantSpacesSpaceTokenEditLazyImport = createFileRoute(
  '/_layout/tenant/spaces/$spaceToken/edit',
)()
const LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyImport =
  createFileRoute(
    '/_layout/tenant/employees/groups/$groupToken/_layout/booking-rules',
  )()

// Create/Update Routes

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const commonForgotPasswordLazyRoute = commonForgotPasswordLazyImport
  .update({
    id: '/(common)/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import('./routes/(common)/forgot-password.lazy').then((d) => d.Route),
  )

const commonSetUpPasswordRoute = commonSetUpPasswordImport.update({
  id: '/(common)/set-up-password',
  path: '/set-up-password',
  getParentRoute: () => rootRoute,
} as any)

const commonResetPasswordRoute = commonResetPasswordImport.update({
  id: '/(common)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const commonLoginRoute = commonLoginImport.update({
  id: '/(common)/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const LayoutTenantSpacesRoute = LayoutTenantSpacesImport.update({
  id: '/tenant/spaces',
  path: '/tenant/spaces',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTenantOrganizationDetailsRoute =
  LayoutTenantOrganizationDetailsImport.update({
    id: '/tenant/organization-details',
    path: '/tenant/organization-details',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTenantEmployeesRoute = LayoutTenantEmployeesImport.update({
  id: '/tenant/employees',
  path: '/tenant/employees',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTenantBookingsRoute = LayoutTenantBookingsImport.update({
  id: '/tenant/bookings',
  path: '/tenant/bookings',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTenantIndexLazyRoute = LayoutTenantIndexLazyImport.update({
  id: '/tenant/',
  path: '/tenant/',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/tenant/index.lazy').then((d) => d.Route),
)

const LayoutSiteIndexLazyRoute = LayoutSiteIndexLazyImport.update({
  id: '/site/',
  path: '/site/',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/site/index.lazy').then((d) => d.Route),
)

const LayoutTenantPasswordLazyRoute = LayoutTenantPasswordLazyImport.update({
  id: '/tenant/password',
  path: '/tenant/password',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/tenant/password.lazy').then((d) => d.Route),
)

const LayoutTenantAuditLogsLazyRoute = LayoutTenantAuditLogsLazyImport.update({
  id: '/tenant/audit-logs',
  path: '/tenant/audit-logs',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/tenant/audit-logs.lazy').then((d) => d.Route),
)

const commonTenantInvitationInvitationTokenLazyRoute =
  commonTenantInvitationInvitationTokenLazyImport
    .update({
      id: '/(common)/tenant-invitation_/$invitationToken',
      path: '/tenant-invitation/$invitationToken',
      getParentRoute: () => rootRoute,
    } as any)
    .lazy(() =>
      import('./routes/(common)/tenant-invitation_/$invitationToken.lazy').then(
        (d) => d.Route,
      ),
    )

const LayoutTenantIssuesIndexRoute = LayoutTenantIssuesIndexImport.update({
  id: '/tenant/issues/',
  path: '/tenant/issues/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTenantBookingRulesIndexRoute =
  LayoutTenantBookingRulesIndexImport.update({
    id: '/tenant/booking-rules/',
    path: '/tenant/booking-rules/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTenantSpacesOldFloorPlannerLazyRoute =
  LayoutTenantSpacesOldFloorPlannerLazyImport.update({
    id: '/old-floor-planner',
    path: '/old-floor-planner',
    getParentRoute: () => LayoutTenantSpacesRoute,
  } as any).lazy(() =>
    import('./routes/_layout/tenant/spaces/old-floor-planner.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutTenantSpacesNewerOldFloorPlannerLazyRoute =
  LayoutTenantSpacesNewerOldFloorPlannerLazyImport.update({
    id: '/newer-old-floor-planner',
    path: '/newer-old-floor-planner',
    getParentRoute: () => LayoutTenantSpacesRoute,
  } as any).lazy(() =>
    import('./routes/_layout/tenant/spaces/newer-old-floor-planner.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutTenantSpacesCreateLazyRoute =
  LayoutTenantSpacesCreateLazyImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => LayoutTenantSpacesRoute,
  } as any).lazy(() =>
    import('./routes/_layout/tenant/spaces/create.lazy').then((d) => d.Route),
  )

const LayoutTenantIssuesIssueTokenLazyRoute =
  LayoutTenantIssuesIssueTokenLazyImport.update({
    id: '/tenant/issues/$issueToken',
    path: '/tenant/issues/$issueToken',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/tenant/issues/$issueToken.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutTenantBookingsCreateLazyRoute =
  LayoutTenantBookingsCreateLazyImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => LayoutTenantBookingsRoute,
  } as any).lazy(() =>
    import('./routes/_layout/tenant/bookings/create.lazy').then((d) => d.Route),
  )

const LayoutTenantBookingRulesCreateLazyRoute =
  LayoutTenantBookingRulesCreateLazyImport.update({
    id: '/tenant/booking-rules/create',
    path: '/tenant/booking-rules/create',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/tenant/booking-rules/create.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutTenantBookingRulesBookingRulesTokenLazyRoute =
  LayoutTenantBookingRulesBookingRulesTokenLazyImport.update({
    id: '/tenant/booking-rules/$bookingRulesToken',
    path: '/tenant/booking-rules/$bookingRulesToken',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/tenant/booking-rules/$bookingRulesToken.lazy'
    ).then((d) => d.Route),
  )

const LayoutTenantSpacesLayoutRoute = LayoutTenantSpacesLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => LayoutTenantSpacesRoute,
} as any)

const LayoutTenantOrganizationDetailsLayoutRoute =
  LayoutTenantOrganizationDetailsLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => LayoutTenantOrganizationDetailsRoute,
  } as any)

const LayoutTenantEmployeesLayoutRoute =
  LayoutTenantEmployeesLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => LayoutTenantEmployeesRoute,
  } as any)

const LayoutTenantBookingsLayoutRoute = LayoutTenantBookingsLayoutImport.update(
  {
    id: '/_layout',
    getParentRoute: () => LayoutTenantBookingsRoute,
  } as any,
)

const LayoutTenantEmployeesGroupsGroupTokenRoute =
  LayoutTenantEmployeesGroupsGroupTokenImport.update({
    id: '/groups/$groupToken',
    path: '/groups/$groupToken',
    getParentRoute: () => LayoutTenantEmployeesRoute,
  } as any)

const LayoutTenantOrganizationDetailsLayoutIndexLazyRoute =
  LayoutTenantOrganizationDetailsLayoutIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutTenantOrganizationDetailsLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/tenant/organization-details/_layout/index.lazy'
    ).then((d) => d.Route),
  )

const LayoutTenantStatisticsLayoutIndexRoute =
  LayoutTenantStatisticsLayoutIndexImport.update({
    id: '/tenant/statistics/_layout/',
    path: '/tenant/statistics/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTenantSpacesLayoutIndexRoute =
  LayoutTenantSpacesLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutTenantSpacesLayoutRoute,
  } as any)

const LayoutTenantEmployeesLayoutIndexRoute =
  LayoutTenantEmployeesLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutTenantEmployeesLayoutRoute,
  } as any)

const LayoutTenantBookingsLayoutIndexRoute =
  LayoutTenantBookingsLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutTenantBookingsLayoutRoute,
  } as any)

const LayoutTenantSpacesLayoutFloorPlannerLazyRoute =
  LayoutTenantSpacesLayoutFloorPlannerLazyImport.update({
    id: '/floor-planner',
    path: '/floor-planner',
    getParentRoute: () => LayoutTenantSpacesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/tenant/spaces/_layout/floor-planner.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutTenantSpacesSpaceTokenEditLazyRoute =
  LayoutTenantSpacesSpaceTokenEditLazyImport.update({
    id: '/$spaceToken/edit',
    path: '/$spaceToken/edit',
    getParentRoute: () => LayoutTenantSpacesRoute,
  } as any).lazy(() =>
    import('./routes/_layout/tenant/spaces/$spaceToken/edit.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutTenantSpacesGroupsSpaceGroupTokenRoute =
  LayoutTenantSpacesGroupsSpaceGroupTokenImport.update({
    id: '/groups/$spaceGroupToken',
    path: '/groups/$spaceGroupToken',
    getParentRoute: () => LayoutTenantSpacesRoute,
  } as any)

const LayoutTenantSpacesLayoutGroupsRoute =
  LayoutTenantSpacesLayoutGroupsImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => LayoutTenantSpacesLayoutRoute,
  } as any)

const LayoutTenantOrganizationDetailsLayoutAdminsRoute =
  LayoutTenantOrganizationDetailsLayoutAdminsImport.update({
    id: '/admins',
    path: '/admins',
    getParentRoute: () => LayoutTenantOrganizationDetailsLayoutRoute,
  } as any)

const LayoutTenantEmployeesLayoutGroupsRoute =
  LayoutTenantEmployeesLayoutGroupsImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => LayoutTenantEmployeesLayoutRoute,
  } as any)

const LayoutTenantEmployeesGroupsGroupTokenLayoutRoute =
  LayoutTenantEmployeesGroupsGroupTokenLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => LayoutTenantEmployeesGroupsGroupTokenRoute,
  } as any)

const LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyRoute =
  LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyImport.update({
    id: '/booking-rules',
    path: '/booking-rules',
    getParentRoute: () => LayoutTenantEmployeesGroupsGroupTokenLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/tenant/employees/groups/$groupToken/_layout/booking-rules.lazy'
    ).then((d) => d.Route),
  )

const LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsRoute =
  LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsImport.update({
    id: '/space-groups',
    path: '/space-groups',
    getParentRoute: () => LayoutTenantEmployeesGroupsGroupTokenLayoutRoute,
  } as any)

const LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesRoute =
  LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesImport.update({
    id: '/employees',
    path: '/employees',
    getParentRoute: () => LayoutTenantEmployeesGroupsGroupTokenLayoutRoute,
  } as any)

const LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsRoute =
  LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsImport.update({
    id: '/bookings',
    path: '/bookings',
    getParentRoute: () => LayoutTenantEmployeesGroupsGroupTokenLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/(common)/login': {
      id: '/(common)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof commonLoginImport
      parentRoute: typeof rootRoute
    }
    '/(common)/reset-password': {
      id: '/(common)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof commonResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/(common)/set-up-password': {
      id: '/(common)/set-up-password'
      path: '/set-up-password'
      fullPath: '/set-up-password'
      preLoaderRoute: typeof commonSetUpPasswordImport
      parentRoute: typeof rootRoute
    }
    '/(common)/forgot-password': {
      id: '/(common)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof commonForgotPasswordLazyImport
      parentRoute: typeof rootRoute
    }
    '/(common)/tenant-invitation_/$invitationToken': {
      id: '/(common)/tenant-invitation_/$invitationToken'
      path: '/tenant-invitation/$invitationToken'
      fullPath: '/tenant-invitation/$invitationToken'
      preLoaderRoute: typeof commonTenantInvitationInvitationTokenLazyImport
      parentRoute: typeof rootRoute
    }
    '/_layout/tenant/audit-logs': {
      id: '/_layout/tenant/audit-logs'
      path: '/tenant/audit-logs'
      fullPath: '/tenant/audit-logs'
      preLoaderRoute: typeof LayoutTenantAuditLogsLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/password': {
      id: '/_layout/tenant/password'
      path: '/tenant/password'
      fullPath: '/tenant/password'
      preLoaderRoute: typeof LayoutTenantPasswordLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/site/': {
      id: '/_layout/site/'
      path: '/site'
      fullPath: '/site'
      preLoaderRoute: typeof LayoutSiteIndexLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/': {
      id: '/_layout/tenant/'
      path: '/tenant'
      fullPath: '/tenant'
      preLoaderRoute: typeof LayoutTenantIndexLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/bookings': {
      id: '/_layout/tenant/bookings'
      path: '/tenant/bookings'
      fullPath: '/tenant/bookings'
      preLoaderRoute: typeof LayoutTenantBookingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/bookings/_layout': {
      id: '/_layout/tenant/bookings/_layout'
      path: '/tenant/bookings'
      fullPath: '/tenant/bookings'
      preLoaderRoute: typeof LayoutTenantBookingsLayoutImport
      parentRoute: typeof LayoutTenantBookingsRoute
    }
    '/_layout/tenant/employees': {
      id: '/_layout/tenant/employees'
      path: '/tenant/employees'
      fullPath: '/tenant/employees'
      preLoaderRoute: typeof LayoutTenantEmployeesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/employees/_layout': {
      id: '/_layout/tenant/employees/_layout'
      path: '/tenant/employees'
      fullPath: '/tenant/employees'
      preLoaderRoute: typeof LayoutTenantEmployeesLayoutImport
      parentRoute: typeof LayoutTenantEmployeesRoute
    }
    '/_layout/tenant/organization-details': {
      id: '/_layout/tenant/organization-details'
      path: '/tenant/organization-details'
      fullPath: '/tenant/organization-details'
      preLoaderRoute: typeof LayoutTenantOrganizationDetailsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/organization-details/_layout': {
      id: '/_layout/tenant/organization-details/_layout'
      path: '/tenant/organization-details'
      fullPath: '/tenant/organization-details'
      preLoaderRoute: typeof LayoutTenantOrganizationDetailsLayoutImport
      parentRoute: typeof LayoutTenantOrganizationDetailsRoute
    }
    '/_layout/tenant/spaces': {
      id: '/_layout/tenant/spaces'
      path: '/tenant/spaces'
      fullPath: '/tenant/spaces'
      preLoaderRoute: typeof LayoutTenantSpacesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/spaces/_layout': {
      id: '/_layout/tenant/spaces/_layout'
      path: '/tenant/spaces'
      fullPath: '/tenant/spaces'
      preLoaderRoute: typeof LayoutTenantSpacesLayoutImport
      parentRoute: typeof LayoutTenantSpacesRoute
    }
    '/_layout/tenant/booking-rules/$bookingRulesToken': {
      id: '/_layout/tenant/booking-rules/$bookingRulesToken'
      path: '/tenant/booking-rules/$bookingRulesToken'
      fullPath: '/tenant/booking-rules/$bookingRulesToken'
      preLoaderRoute: typeof LayoutTenantBookingRulesBookingRulesTokenLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/booking-rules/create': {
      id: '/_layout/tenant/booking-rules/create'
      path: '/tenant/booking-rules/create'
      fullPath: '/tenant/booking-rules/create'
      preLoaderRoute: typeof LayoutTenantBookingRulesCreateLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/bookings/create': {
      id: '/_layout/tenant/bookings/create'
      path: '/create'
      fullPath: '/tenant/bookings/create'
      preLoaderRoute: typeof LayoutTenantBookingsCreateLazyImport
      parentRoute: typeof LayoutTenantBookingsImport
    }
    '/_layout/tenant/issues/$issueToken': {
      id: '/_layout/tenant/issues/$issueToken'
      path: '/tenant/issues/$issueToken'
      fullPath: '/tenant/issues/$issueToken'
      preLoaderRoute: typeof LayoutTenantIssuesIssueTokenLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/spaces/create': {
      id: '/_layout/tenant/spaces/create'
      path: '/create'
      fullPath: '/tenant/spaces/create'
      preLoaderRoute: typeof LayoutTenantSpacesCreateLazyImport
      parentRoute: typeof LayoutTenantSpacesImport
    }
    '/_layout/tenant/spaces/newer-old-floor-planner': {
      id: '/_layout/tenant/spaces/newer-old-floor-planner'
      path: '/newer-old-floor-planner'
      fullPath: '/tenant/spaces/newer-old-floor-planner'
      preLoaderRoute: typeof LayoutTenantSpacesNewerOldFloorPlannerLazyImport
      parentRoute: typeof LayoutTenantSpacesImport
    }
    '/_layout/tenant/spaces/old-floor-planner': {
      id: '/_layout/tenant/spaces/old-floor-planner'
      path: '/old-floor-planner'
      fullPath: '/tenant/spaces/old-floor-planner'
      preLoaderRoute: typeof LayoutTenantSpacesOldFloorPlannerLazyImport
      parentRoute: typeof LayoutTenantSpacesImport
    }
    '/_layout/tenant/booking-rules/': {
      id: '/_layout/tenant/booking-rules/'
      path: '/tenant/booking-rules'
      fullPath: '/tenant/booking-rules'
      preLoaderRoute: typeof LayoutTenantBookingRulesIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/issues/': {
      id: '/_layout/tenant/issues/'
      path: '/tenant/issues'
      fullPath: '/tenant/issues'
      preLoaderRoute: typeof LayoutTenantIssuesIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/employees/_layout/groups': {
      id: '/_layout/tenant/employees/_layout/groups'
      path: '/groups'
      fullPath: '/tenant/employees/groups'
      preLoaderRoute: typeof LayoutTenantEmployeesLayoutGroupsImport
      parentRoute: typeof LayoutTenantEmployeesLayoutImport
    }
    '/_layout/tenant/organization-details/_layout/admins': {
      id: '/_layout/tenant/organization-details/_layout/admins'
      path: '/admins'
      fullPath: '/tenant/organization-details/admins'
      preLoaderRoute: typeof LayoutTenantOrganizationDetailsLayoutAdminsImport
      parentRoute: typeof LayoutTenantOrganizationDetailsLayoutImport
    }
    '/_layout/tenant/spaces/_layout/groups': {
      id: '/_layout/tenant/spaces/_layout/groups'
      path: '/groups'
      fullPath: '/tenant/spaces/groups'
      preLoaderRoute: typeof LayoutTenantSpacesLayoutGroupsImport
      parentRoute: typeof LayoutTenantSpacesLayoutImport
    }
    '/_layout/tenant/spaces/groups/$spaceGroupToken': {
      id: '/_layout/tenant/spaces/groups/$spaceGroupToken'
      path: '/groups/$spaceGroupToken'
      fullPath: '/tenant/spaces/groups/$spaceGroupToken'
      preLoaderRoute: typeof LayoutTenantSpacesGroupsSpaceGroupTokenImport
      parentRoute: typeof LayoutTenantSpacesImport
    }
    '/_layout/tenant/spaces/$spaceToken/edit': {
      id: '/_layout/tenant/spaces/$spaceToken/edit'
      path: '/$spaceToken/edit'
      fullPath: '/tenant/spaces/$spaceToken/edit'
      preLoaderRoute: typeof LayoutTenantSpacesSpaceTokenEditLazyImport
      parentRoute: typeof LayoutTenantSpacesImport
    }
    '/_layout/tenant/spaces/_layout/floor-planner': {
      id: '/_layout/tenant/spaces/_layout/floor-planner'
      path: '/floor-planner'
      fullPath: '/tenant/spaces/floor-planner'
      preLoaderRoute: typeof LayoutTenantSpacesLayoutFloorPlannerLazyImport
      parentRoute: typeof LayoutTenantSpacesLayoutImport
    }
    '/_layout/tenant/bookings/_layout/': {
      id: '/_layout/tenant/bookings/_layout/'
      path: '/'
      fullPath: '/tenant/bookings/'
      preLoaderRoute: typeof LayoutTenantBookingsLayoutIndexImport
      parentRoute: typeof LayoutTenantBookingsLayoutImport
    }
    '/_layout/tenant/employees/_layout/': {
      id: '/_layout/tenant/employees/_layout/'
      path: '/'
      fullPath: '/tenant/employees/'
      preLoaderRoute: typeof LayoutTenantEmployeesLayoutIndexImport
      parentRoute: typeof LayoutTenantEmployeesLayoutImport
    }
    '/_layout/tenant/spaces/_layout/': {
      id: '/_layout/tenant/spaces/_layout/'
      path: '/'
      fullPath: '/tenant/spaces/'
      preLoaderRoute: typeof LayoutTenantSpacesLayoutIndexImport
      parentRoute: typeof LayoutTenantSpacesLayoutImport
    }
    '/_layout/tenant/statistics/_layout/': {
      id: '/_layout/tenant/statistics/_layout/'
      path: '/tenant/statistics'
      fullPath: '/tenant/statistics'
      preLoaderRoute: typeof LayoutTenantStatisticsLayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tenant/organization-details/_layout/': {
      id: '/_layout/tenant/organization-details/_layout/'
      path: '/'
      fullPath: '/tenant/organization-details/'
      preLoaderRoute: typeof LayoutTenantOrganizationDetailsLayoutIndexLazyImport
      parentRoute: typeof LayoutTenantOrganizationDetailsLayoutImport
    }
    '/_layout/tenant/employees/groups/$groupToken': {
      id: '/_layout/tenant/employees/groups/$groupToken'
      path: '/groups/$groupToken'
      fullPath: '/tenant/employees/groups/$groupToken'
      preLoaderRoute: typeof LayoutTenantEmployeesGroupsGroupTokenImport
      parentRoute: typeof LayoutTenantEmployeesImport
    }
    '/_layout/tenant/employees/groups/$groupToken/_layout': {
      id: '/_layout/tenant/employees/groups/$groupToken/_layout'
      path: '/groups/$groupToken'
      fullPath: '/tenant/employees/groups/$groupToken'
      preLoaderRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutImport
      parentRoute: typeof LayoutTenantEmployeesGroupsGroupTokenRoute
    }
    '/_layout/tenant/employees/groups/$groupToken/_layout/bookings': {
      id: '/_layout/tenant/employees/groups/$groupToken/_layout/bookings'
      path: '/bookings'
      fullPath: '/tenant/employees/groups/$groupToken/bookings'
      preLoaderRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsImport
      parentRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutImport
    }
    '/_layout/tenant/employees/groups/$groupToken/_layout/employees': {
      id: '/_layout/tenant/employees/groups/$groupToken/_layout/employees'
      path: '/employees'
      fullPath: '/tenant/employees/groups/$groupToken/employees'
      preLoaderRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesImport
      parentRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutImport
    }
    '/_layout/tenant/employees/groups/$groupToken/_layout/space-groups': {
      id: '/_layout/tenant/employees/groups/$groupToken/_layout/space-groups'
      path: '/space-groups'
      fullPath: '/tenant/employees/groups/$groupToken/space-groups'
      preLoaderRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsImport
      parentRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutImport
    }
    '/_layout/tenant/employees/groups/$groupToken/_layout/booking-rules': {
      id: '/_layout/tenant/employees/groups/$groupToken/_layout/booking-rules'
      path: '/booking-rules'
      fullPath: '/tenant/employees/groups/$groupToken/booking-rules'
      preLoaderRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyImport
      parentRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutImport
    }
  }
}

// Create and export the route tree

interface LayoutTenantBookingsLayoutRouteChildren {
  LayoutTenantBookingsLayoutIndexRoute: typeof LayoutTenantBookingsLayoutIndexRoute
}

const LayoutTenantBookingsLayoutRouteChildren: LayoutTenantBookingsLayoutRouteChildren =
  {
    LayoutTenantBookingsLayoutIndexRoute: LayoutTenantBookingsLayoutIndexRoute,
  }

const LayoutTenantBookingsLayoutRouteWithChildren =
  LayoutTenantBookingsLayoutRoute._addFileChildren(
    LayoutTenantBookingsLayoutRouteChildren,
  )

interface LayoutTenantBookingsRouteChildren {
  LayoutTenantBookingsLayoutRoute: typeof LayoutTenantBookingsLayoutRouteWithChildren
  LayoutTenantBookingsCreateLazyRoute: typeof LayoutTenantBookingsCreateLazyRoute
}

const LayoutTenantBookingsRouteChildren: LayoutTenantBookingsRouteChildren = {
  LayoutTenantBookingsLayoutRoute: LayoutTenantBookingsLayoutRouteWithChildren,
  LayoutTenantBookingsCreateLazyRoute: LayoutTenantBookingsCreateLazyRoute,
}

const LayoutTenantBookingsRouteWithChildren =
  LayoutTenantBookingsRoute._addFileChildren(LayoutTenantBookingsRouteChildren)

interface LayoutTenantEmployeesLayoutRouteChildren {
  LayoutTenantEmployeesLayoutGroupsRoute: typeof LayoutTenantEmployeesLayoutGroupsRoute
  LayoutTenantEmployeesLayoutIndexRoute: typeof LayoutTenantEmployeesLayoutIndexRoute
}

const LayoutTenantEmployeesLayoutRouteChildren: LayoutTenantEmployeesLayoutRouteChildren =
  {
    LayoutTenantEmployeesLayoutGroupsRoute:
      LayoutTenantEmployeesLayoutGroupsRoute,
    LayoutTenantEmployeesLayoutIndexRoute:
      LayoutTenantEmployeesLayoutIndexRoute,
  }

const LayoutTenantEmployeesLayoutRouteWithChildren =
  LayoutTenantEmployeesLayoutRoute._addFileChildren(
    LayoutTenantEmployeesLayoutRouteChildren,
  )

interface LayoutTenantEmployeesGroupsGroupTokenLayoutRouteChildren {
  LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsRoute
  LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesRoute
  LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsRoute
  LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyRoute
}

const LayoutTenantEmployeesGroupsGroupTokenLayoutRouteChildren: LayoutTenantEmployeesGroupsGroupTokenLayoutRouteChildren =
  {
    LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsRoute:
      LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsRoute,
    LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesRoute:
      LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesRoute,
    LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsRoute:
      LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsRoute,
    LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyRoute:
      LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyRoute,
  }

const LayoutTenantEmployeesGroupsGroupTokenLayoutRouteWithChildren =
  LayoutTenantEmployeesGroupsGroupTokenLayoutRoute._addFileChildren(
    LayoutTenantEmployeesGroupsGroupTokenLayoutRouteChildren,
  )

interface LayoutTenantEmployeesGroupsGroupTokenRouteChildren {
  LayoutTenantEmployeesGroupsGroupTokenLayoutRoute: typeof LayoutTenantEmployeesGroupsGroupTokenLayoutRouteWithChildren
}

const LayoutTenantEmployeesGroupsGroupTokenRouteChildren: LayoutTenantEmployeesGroupsGroupTokenRouteChildren =
  {
    LayoutTenantEmployeesGroupsGroupTokenLayoutRoute:
      LayoutTenantEmployeesGroupsGroupTokenLayoutRouteWithChildren,
  }

const LayoutTenantEmployeesGroupsGroupTokenRouteWithChildren =
  LayoutTenantEmployeesGroupsGroupTokenRoute._addFileChildren(
    LayoutTenantEmployeesGroupsGroupTokenRouteChildren,
  )

interface LayoutTenantEmployeesRouteChildren {
  LayoutTenantEmployeesLayoutRoute: typeof LayoutTenantEmployeesLayoutRouteWithChildren
  LayoutTenantEmployeesGroupsGroupTokenRoute: typeof LayoutTenantEmployeesGroupsGroupTokenRouteWithChildren
}

const LayoutTenantEmployeesRouteChildren: LayoutTenantEmployeesRouteChildren = {
  LayoutTenantEmployeesLayoutRoute:
    LayoutTenantEmployeesLayoutRouteWithChildren,
  LayoutTenantEmployeesGroupsGroupTokenRoute:
    LayoutTenantEmployeesGroupsGroupTokenRouteWithChildren,
}

const LayoutTenantEmployeesRouteWithChildren =
  LayoutTenantEmployeesRoute._addFileChildren(
    LayoutTenantEmployeesRouteChildren,
  )

interface LayoutTenantOrganizationDetailsLayoutRouteChildren {
  LayoutTenantOrganizationDetailsLayoutAdminsRoute: typeof LayoutTenantOrganizationDetailsLayoutAdminsRoute
  LayoutTenantOrganizationDetailsLayoutIndexLazyRoute: typeof LayoutTenantOrganizationDetailsLayoutIndexLazyRoute
}

const LayoutTenantOrganizationDetailsLayoutRouteChildren: LayoutTenantOrganizationDetailsLayoutRouteChildren =
  {
    LayoutTenantOrganizationDetailsLayoutAdminsRoute:
      LayoutTenantOrganizationDetailsLayoutAdminsRoute,
    LayoutTenantOrganizationDetailsLayoutIndexLazyRoute:
      LayoutTenantOrganizationDetailsLayoutIndexLazyRoute,
  }

const LayoutTenantOrganizationDetailsLayoutRouteWithChildren =
  LayoutTenantOrganizationDetailsLayoutRoute._addFileChildren(
    LayoutTenantOrganizationDetailsLayoutRouteChildren,
  )

interface LayoutTenantOrganizationDetailsRouteChildren {
  LayoutTenantOrganizationDetailsLayoutRoute: typeof LayoutTenantOrganizationDetailsLayoutRouteWithChildren
}

const LayoutTenantOrganizationDetailsRouteChildren: LayoutTenantOrganizationDetailsRouteChildren =
  {
    LayoutTenantOrganizationDetailsLayoutRoute:
      LayoutTenantOrganizationDetailsLayoutRouteWithChildren,
  }

const LayoutTenantOrganizationDetailsRouteWithChildren =
  LayoutTenantOrganizationDetailsRoute._addFileChildren(
    LayoutTenantOrganizationDetailsRouteChildren,
  )

interface LayoutTenantSpacesLayoutRouteChildren {
  LayoutTenantSpacesLayoutGroupsRoute: typeof LayoutTenantSpacesLayoutGroupsRoute
  LayoutTenantSpacesLayoutFloorPlannerLazyRoute: typeof LayoutTenantSpacesLayoutFloorPlannerLazyRoute
  LayoutTenantSpacesLayoutIndexRoute: typeof LayoutTenantSpacesLayoutIndexRoute
}

const LayoutTenantSpacesLayoutRouteChildren: LayoutTenantSpacesLayoutRouteChildren =
  {
    LayoutTenantSpacesLayoutGroupsRoute: LayoutTenantSpacesLayoutGroupsRoute,
    LayoutTenantSpacesLayoutFloorPlannerLazyRoute:
      LayoutTenantSpacesLayoutFloorPlannerLazyRoute,
    LayoutTenantSpacesLayoutIndexRoute: LayoutTenantSpacesLayoutIndexRoute,
  }

const LayoutTenantSpacesLayoutRouteWithChildren =
  LayoutTenantSpacesLayoutRoute._addFileChildren(
    LayoutTenantSpacesLayoutRouteChildren,
  )

interface LayoutTenantSpacesRouteChildren {
  LayoutTenantSpacesLayoutRoute: typeof LayoutTenantSpacesLayoutRouteWithChildren
  LayoutTenantSpacesCreateLazyRoute: typeof LayoutTenantSpacesCreateLazyRoute
  LayoutTenantSpacesNewerOldFloorPlannerLazyRoute: typeof LayoutTenantSpacesNewerOldFloorPlannerLazyRoute
  LayoutTenantSpacesOldFloorPlannerLazyRoute: typeof LayoutTenantSpacesOldFloorPlannerLazyRoute
  LayoutTenantSpacesGroupsSpaceGroupTokenRoute: typeof LayoutTenantSpacesGroupsSpaceGroupTokenRoute
  LayoutTenantSpacesSpaceTokenEditLazyRoute: typeof LayoutTenantSpacesSpaceTokenEditLazyRoute
}

const LayoutTenantSpacesRouteChildren: LayoutTenantSpacesRouteChildren = {
  LayoutTenantSpacesLayoutRoute: LayoutTenantSpacesLayoutRouteWithChildren,
  LayoutTenantSpacesCreateLazyRoute: LayoutTenantSpacesCreateLazyRoute,
  LayoutTenantSpacesNewerOldFloorPlannerLazyRoute:
    LayoutTenantSpacesNewerOldFloorPlannerLazyRoute,
  LayoutTenantSpacesOldFloorPlannerLazyRoute:
    LayoutTenantSpacesOldFloorPlannerLazyRoute,
  LayoutTenantSpacesGroupsSpaceGroupTokenRoute:
    LayoutTenantSpacesGroupsSpaceGroupTokenRoute,
  LayoutTenantSpacesSpaceTokenEditLazyRoute:
    LayoutTenantSpacesSpaceTokenEditLazyRoute,
}

const LayoutTenantSpacesRouteWithChildren =
  LayoutTenantSpacesRoute._addFileChildren(LayoutTenantSpacesRouteChildren)

interface LayoutRouteChildren {
  LayoutTenantAuditLogsLazyRoute: typeof LayoutTenantAuditLogsLazyRoute
  LayoutTenantPasswordLazyRoute: typeof LayoutTenantPasswordLazyRoute
  LayoutSiteIndexLazyRoute: typeof LayoutSiteIndexLazyRoute
  LayoutTenantIndexLazyRoute: typeof LayoutTenantIndexLazyRoute
  LayoutTenantBookingsRoute: typeof LayoutTenantBookingsRouteWithChildren
  LayoutTenantEmployeesRoute: typeof LayoutTenantEmployeesRouteWithChildren
  LayoutTenantOrganizationDetailsRoute: typeof LayoutTenantOrganizationDetailsRouteWithChildren
  LayoutTenantSpacesRoute: typeof LayoutTenantSpacesRouteWithChildren
  LayoutTenantBookingRulesBookingRulesTokenLazyRoute: typeof LayoutTenantBookingRulesBookingRulesTokenLazyRoute
  LayoutTenantBookingRulesCreateLazyRoute: typeof LayoutTenantBookingRulesCreateLazyRoute
  LayoutTenantIssuesIssueTokenLazyRoute: typeof LayoutTenantIssuesIssueTokenLazyRoute
  LayoutTenantBookingRulesIndexRoute: typeof LayoutTenantBookingRulesIndexRoute
  LayoutTenantIssuesIndexRoute: typeof LayoutTenantIssuesIndexRoute
  LayoutTenantStatisticsLayoutIndexRoute: typeof LayoutTenantStatisticsLayoutIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutTenantAuditLogsLazyRoute: LayoutTenantAuditLogsLazyRoute,
  LayoutTenantPasswordLazyRoute: LayoutTenantPasswordLazyRoute,
  LayoutSiteIndexLazyRoute: LayoutSiteIndexLazyRoute,
  LayoutTenantIndexLazyRoute: LayoutTenantIndexLazyRoute,
  LayoutTenantBookingsRoute: LayoutTenantBookingsRouteWithChildren,
  LayoutTenantEmployeesRoute: LayoutTenantEmployeesRouteWithChildren,
  LayoutTenantOrganizationDetailsRoute:
    LayoutTenantOrganizationDetailsRouteWithChildren,
  LayoutTenantSpacesRoute: LayoutTenantSpacesRouteWithChildren,
  LayoutTenantBookingRulesBookingRulesTokenLazyRoute:
    LayoutTenantBookingRulesBookingRulesTokenLazyRoute,
  LayoutTenantBookingRulesCreateLazyRoute:
    LayoutTenantBookingRulesCreateLazyRoute,
  LayoutTenantIssuesIssueTokenLazyRoute: LayoutTenantIssuesIssueTokenLazyRoute,
  LayoutTenantBookingRulesIndexRoute: LayoutTenantBookingRulesIndexRoute,
  LayoutTenantIssuesIndexRoute: LayoutTenantIssuesIndexRoute,
  LayoutTenantStatisticsLayoutIndexRoute:
    LayoutTenantStatisticsLayoutIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '': typeof LayoutRouteWithChildren
  '/login': typeof commonLoginRoute
  '/reset-password': typeof commonResetPasswordRoute
  '/set-up-password': typeof commonSetUpPasswordRoute
  '/forgot-password': typeof commonForgotPasswordLazyRoute
  '/tenant-invitation/$invitationToken': typeof commonTenantInvitationInvitationTokenLazyRoute
  '/tenant/audit-logs': typeof LayoutTenantAuditLogsLazyRoute
  '/tenant/password': typeof LayoutTenantPasswordLazyRoute
  '/site': typeof LayoutSiteIndexLazyRoute
  '/tenant': typeof LayoutTenantIndexLazyRoute
  '/tenant/bookings': typeof LayoutTenantBookingsLayoutRouteWithChildren
  '/tenant/employees': typeof LayoutTenantEmployeesLayoutRouteWithChildren
  '/tenant/organization-details': typeof LayoutTenantOrganizationDetailsLayoutRouteWithChildren
  '/tenant/spaces': typeof LayoutTenantSpacesLayoutRouteWithChildren
  '/tenant/booking-rules/$bookingRulesToken': typeof LayoutTenantBookingRulesBookingRulesTokenLazyRoute
  '/tenant/booking-rules/create': typeof LayoutTenantBookingRulesCreateLazyRoute
  '/tenant/bookings/create': typeof LayoutTenantBookingsCreateLazyRoute
  '/tenant/issues/$issueToken': typeof LayoutTenantIssuesIssueTokenLazyRoute
  '/tenant/spaces/create': typeof LayoutTenantSpacesCreateLazyRoute
  '/tenant/spaces/newer-old-floor-planner': typeof LayoutTenantSpacesNewerOldFloorPlannerLazyRoute
  '/tenant/spaces/old-floor-planner': typeof LayoutTenantSpacesOldFloorPlannerLazyRoute
  '/tenant/booking-rules': typeof LayoutTenantBookingRulesIndexRoute
  '/tenant/issues': typeof LayoutTenantIssuesIndexRoute
  '/tenant/employees/groups': typeof LayoutTenantEmployeesLayoutGroupsRoute
  '/tenant/organization-details/admins': typeof LayoutTenantOrganizationDetailsLayoutAdminsRoute
  '/tenant/spaces/groups': typeof LayoutTenantSpacesLayoutGroupsRoute
  '/tenant/spaces/groups/$spaceGroupToken': typeof LayoutTenantSpacesGroupsSpaceGroupTokenRoute
  '/tenant/spaces/$spaceToken/edit': typeof LayoutTenantSpacesSpaceTokenEditLazyRoute
  '/tenant/spaces/floor-planner': typeof LayoutTenantSpacesLayoutFloorPlannerLazyRoute
  '/tenant/bookings/': typeof LayoutTenantBookingsLayoutIndexRoute
  '/tenant/employees/': typeof LayoutTenantEmployeesLayoutIndexRoute
  '/tenant/spaces/': typeof LayoutTenantSpacesLayoutIndexRoute
  '/tenant/statistics': typeof LayoutTenantStatisticsLayoutIndexRoute
  '/tenant/organization-details/': typeof LayoutTenantOrganizationDetailsLayoutIndexLazyRoute
  '/tenant/employees/groups/$groupToken': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutRouteWithChildren
  '/tenant/employees/groups/$groupToken/bookings': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsRoute
  '/tenant/employees/groups/$groupToken/employees': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesRoute
  '/tenant/employees/groups/$groupToken/space-groups': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsRoute
  '/tenant/employees/groups/$groupToken/booking-rules': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '': typeof LayoutRouteWithChildren
  '/login': typeof commonLoginRoute
  '/reset-password': typeof commonResetPasswordRoute
  '/set-up-password': typeof commonSetUpPasswordRoute
  '/forgot-password': typeof commonForgotPasswordLazyRoute
  '/tenant-invitation/$invitationToken': typeof commonTenantInvitationInvitationTokenLazyRoute
  '/tenant/audit-logs': typeof LayoutTenantAuditLogsLazyRoute
  '/tenant/password': typeof LayoutTenantPasswordLazyRoute
  '/site': typeof LayoutSiteIndexLazyRoute
  '/tenant': typeof LayoutTenantIndexLazyRoute
  '/tenant/bookings': typeof LayoutTenantBookingsLayoutIndexRoute
  '/tenant/employees': typeof LayoutTenantEmployeesLayoutIndexRoute
  '/tenant/organization-details': typeof LayoutTenantOrganizationDetailsLayoutIndexLazyRoute
  '/tenant/spaces': typeof LayoutTenantSpacesLayoutIndexRoute
  '/tenant/booking-rules/$bookingRulesToken': typeof LayoutTenantBookingRulesBookingRulesTokenLazyRoute
  '/tenant/booking-rules/create': typeof LayoutTenantBookingRulesCreateLazyRoute
  '/tenant/bookings/create': typeof LayoutTenantBookingsCreateLazyRoute
  '/tenant/issues/$issueToken': typeof LayoutTenantIssuesIssueTokenLazyRoute
  '/tenant/spaces/create': typeof LayoutTenantSpacesCreateLazyRoute
  '/tenant/spaces/newer-old-floor-planner': typeof LayoutTenantSpacesNewerOldFloorPlannerLazyRoute
  '/tenant/spaces/old-floor-planner': typeof LayoutTenantSpacesOldFloorPlannerLazyRoute
  '/tenant/booking-rules': typeof LayoutTenantBookingRulesIndexRoute
  '/tenant/issues': typeof LayoutTenantIssuesIndexRoute
  '/tenant/employees/groups': typeof LayoutTenantEmployeesLayoutGroupsRoute
  '/tenant/organization-details/admins': typeof LayoutTenantOrganizationDetailsLayoutAdminsRoute
  '/tenant/spaces/groups': typeof LayoutTenantSpacesLayoutGroupsRoute
  '/tenant/spaces/groups/$spaceGroupToken': typeof LayoutTenantSpacesGroupsSpaceGroupTokenRoute
  '/tenant/spaces/$spaceToken/edit': typeof LayoutTenantSpacesSpaceTokenEditLazyRoute
  '/tenant/spaces/floor-planner': typeof LayoutTenantSpacesLayoutFloorPlannerLazyRoute
  '/tenant/statistics': typeof LayoutTenantStatisticsLayoutIndexRoute
  '/tenant/employees/groups/$groupToken': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutRouteWithChildren
  '/tenant/employees/groups/$groupToken/bookings': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsRoute
  '/tenant/employees/groups/$groupToken/employees': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesRoute
  '/tenant/employees/groups/$groupToken/space-groups': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsRoute
  '/tenant/employees/groups/$groupToken/booking-rules': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/(common)/login': typeof commonLoginRoute
  '/(common)/reset-password': typeof commonResetPasswordRoute
  '/(common)/set-up-password': typeof commonSetUpPasswordRoute
  '/(common)/forgot-password': typeof commonForgotPasswordLazyRoute
  '/(common)/tenant-invitation_/$invitationToken': typeof commonTenantInvitationInvitationTokenLazyRoute
  '/_layout/tenant/audit-logs': typeof LayoutTenantAuditLogsLazyRoute
  '/_layout/tenant/password': typeof LayoutTenantPasswordLazyRoute
  '/_layout/site/': typeof LayoutSiteIndexLazyRoute
  '/_layout/tenant/': typeof LayoutTenantIndexLazyRoute
  '/_layout/tenant/bookings': typeof LayoutTenantBookingsRouteWithChildren
  '/_layout/tenant/bookings/_layout': typeof LayoutTenantBookingsLayoutRouteWithChildren
  '/_layout/tenant/employees': typeof LayoutTenantEmployeesRouteWithChildren
  '/_layout/tenant/employees/_layout': typeof LayoutTenantEmployeesLayoutRouteWithChildren
  '/_layout/tenant/organization-details': typeof LayoutTenantOrganizationDetailsRouteWithChildren
  '/_layout/tenant/organization-details/_layout': typeof LayoutTenantOrganizationDetailsLayoutRouteWithChildren
  '/_layout/tenant/spaces': typeof LayoutTenantSpacesRouteWithChildren
  '/_layout/tenant/spaces/_layout': typeof LayoutTenantSpacesLayoutRouteWithChildren
  '/_layout/tenant/booking-rules/$bookingRulesToken': typeof LayoutTenantBookingRulesBookingRulesTokenLazyRoute
  '/_layout/tenant/booking-rules/create': typeof LayoutTenantBookingRulesCreateLazyRoute
  '/_layout/tenant/bookings/create': typeof LayoutTenantBookingsCreateLazyRoute
  '/_layout/tenant/issues/$issueToken': typeof LayoutTenantIssuesIssueTokenLazyRoute
  '/_layout/tenant/spaces/create': typeof LayoutTenantSpacesCreateLazyRoute
  '/_layout/tenant/spaces/newer-old-floor-planner': typeof LayoutTenantSpacesNewerOldFloorPlannerLazyRoute
  '/_layout/tenant/spaces/old-floor-planner': typeof LayoutTenantSpacesOldFloorPlannerLazyRoute
  '/_layout/tenant/booking-rules/': typeof LayoutTenantBookingRulesIndexRoute
  '/_layout/tenant/issues/': typeof LayoutTenantIssuesIndexRoute
  '/_layout/tenant/employees/_layout/groups': typeof LayoutTenantEmployeesLayoutGroupsRoute
  '/_layout/tenant/organization-details/_layout/admins': typeof LayoutTenantOrganizationDetailsLayoutAdminsRoute
  '/_layout/tenant/spaces/_layout/groups': typeof LayoutTenantSpacesLayoutGroupsRoute
  '/_layout/tenant/spaces/groups/$spaceGroupToken': typeof LayoutTenantSpacesGroupsSpaceGroupTokenRoute
  '/_layout/tenant/spaces/$spaceToken/edit': typeof LayoutTenantSpacesSpaceTokenEditLazyRoute
  '/_layout/tenant/spaces/_layout/floor-planner': typeof LayoutTenantSpacesLayoutFloorPlannerLazyRoute
  '/_layout/tenant/bookings/_layout/': typeof LayoutTenantBookingsLayoutIndexRoute
  '/_layout/tenant/employees/_layout/': typeof LayoutTenantEmployeesLayoutIndexRoute
  '/_layout/tenant/spaces/_layout/': typeof LayoutTenantSpacesLayoutIndexRoute
  '/_layout/tenant/statistics/_layout/': typeof LayoutTenantStatisticsLayoutIndexRoute
  '/_layout/tenant/organization-details/_layout/': typeof LayoutTenantOrganizationDetailsLayoutIndexLazyRoute
  '/_layout/tenant/employees/groups/$groupToken': typeof LayoutTenantEmployeesGroupsGroupTokenRouteWithChildren
  '/_layout/tenant/employees/groups/$groupToken/_layout': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutRouteWithChildren
  '/_layout/tenant/employees/groups/$groupToken/_layout/bookings': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingsRoute
  '/_layout/tenant/employees/groups/$groupToken/_layout/employees': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutEmployeesRoute
  '/_layout/tenant/employees/groups/$groupToken/_layout/space-groups': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutSpaceGroupsRoute
  '/_layout/tenant/employees/groups/$groupToken/_layout/booking-rules': typeof LayoutTenantEmployeesGroupsGroupTokenLayoutBookingRulesLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/reset-password'
    | '/set-up-password'
    | '/forgot-password'
    | '/tenant-invitation/$invitationToken'
    | '/tenant/audit-logs'
    | '/tenant/password'
    | '/site'
    | '/tenant'
    | '/tenant/bookings'
    | '/tenant/employees'
    | '/tenant/organization-details'
    | '/tenant/spaces'
    | '/tenant/booking-rules/$bookingRulesToken'
    | '/tenant/booking-rules/create'
    | '/tenant/bookings/create'
    | '/tenant/issues/$issueToken'
    | '/tenant/spaces/create'
    | '/tenant/spaces/newer-old-floor-planner'
    | '/tenant/spaces/old-floor-planner'
    | '/tenant/booking-rules'
    | '/tenant/issues'
    | '/tenant/employees/groups'
    | '/tenant/organization-details/admins'
    | '/tenant/spaces/groups'
    | '/tenant/spaces/groups/$spaceGroupToken'
    | '/tenant/spaces/$spaceToken/edit'
    | '/tenant/spaces/floor-planner'
    | '/tenant/bookings/'
    | '/tenant/employees/'
    | '/tenant/spaces/'
    | '/tenant/statistics'
    | '/tenant/organization-details/'
    | '/tenant/employees/groups/$groupToken'
    | '/tenant/employees/groups/$groupToken/bookings'
    | '/tenant/employees/groups/$groupToken/employees'
    | '/tenant/employees/groups/$groupToken/space-groups'
    | '/tenant/employees/groups/$groupToken/booking-rules'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/reset-password'
    | '/set-up-password'
    | '/forgot-password'
    | '/tenant-invitation/$invitationToken'
    | '/tenant/audit-logs'
    | '/tenant/password'
    | '/site'
    | '/tenant'
    | '/tenant/bookings'
    | '/tenant/employees'
    | '/tenant/organization-details'
    | '/tenant/spaces'
    | '/tenant/booking-rules/$bookingRulesToken'
    | '/tenant/booking-rules/create'
    | '/tenant/bookings/create'
    | '/tenant/issues/$issueToken'
    | '/tenant/spaces/create'
    | '/tenant/spaces/newer-old-floor-planner'
    | '/tenant/spaces/old-floor-planner'
    | '/tenant/booking-rules'
    | '/tenant/issues'
    | '/tenant/employees/groups'
    | '/tenant/organization-details/admins'
    | '/tenant/spaces/groups'
    | '/tenant/spaces/groups/$spaceGroupToken'
    | '/tenant/spaces/$spaceToken/edit'
    | '/tenant/spaces/floor-planner'
    | '/tenant/statistics'
    | '/tenant/employees/groups/$groupToken'
    | '/tenant/employees/groups/$groupToken/bookings'
    | '/tenant/employees/groups/$groupToken/employees'
    | '/tenant/employees/groups/$groupToken/space-groups'
    | '/tenant/employees/groups/$groupToken/booking-rules'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/(common)/login'
    | '/(common)/reset-password'
    | '/(common)/set-up-password'
    | '/(common)/forgot-password'
    | '/(common)/tenant-invitation_/$invitationToken'
    | '/_layout/tenant/audit-logs'
    | '/_layout/tenant/password'
    | '/_layout/site/'
    | '/_layout/tenant/'
    | '/_layout/tenant/bookings'
    | '/_layout/tenant/bookings/_layout'
    | '/_layout/tenant/employees'
    | '/_layout/tenant/employees/_layout'
    | '/_layout/tenant/organization-details'
    | '/_layout/tenant/organization-details/_layout'
    | '/_layout/tenant/spaces'
    | '/_layout/tenant/spaces/_layout'
    | '/_layout/tenant/booking-rules/$bookingRulesToken'
    | '/_layout/tenant/booking-rules/create'
    | '/_layout/tenant/bookings/create'
    | '/_layout/tenant/issues/$issueToken'
    | '/_layout/tenant/spaces/create'
    | '/_layout/tenant/spaces/newer-old-floor-planner'
    | '/_layout/tenant/spaces/old-floor-planner'
    | '/_layout/tenant/booking-rules/'
    | '/_layout/tenant/issues/'
    | '/_layout/tenant/employees/_layout/groups'
    | '/_layout/tenant/organization-details/_layout/admins'
    | '/_layout/tenant/spaces/_layout/groups'
    | '/_layout/tenant/spaces/groups/$spaceGroupToken'
    | '/_layout/tenant/spaces/$spaceToken/edit'
    | '/_layout/tenant/spaces/_layout/floor-planner'
    | '/_layout/tenant/bookings/_layout/'
    | '/_layout/tenant/employees/_layout/'
    | '/_layout/tenant/spaces/_layout/'
    | '/_layout/tenant/statistics/_layout/'
    | '/_layout/tenant/organization-details/_layout/'
    | '/_layout/tenant/employees/groups/$groupToken'
    | '/_layout/tenant/employees/groups/$groupToken/_layout'
    | '/_layout/tenant/employees/groups/$groupToken/_layout/bookings'
    | '/_layout/tenant/employees/groups/$groupToken/_layout/employees'
    | '/_layout/tenant/employees/groups/$groupToken/_layout/space-groups'
    | '/_layout/tenant/employees/groups/$groupToken/_layout/booking-rules'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  commonLoginRoute: typeof commonLoginRoute
  commonResetPasswordRoute: typeof commonResetPasswordRoute
  commonSetUpPasswordRoute: typeof commonSetUpPasswordRoute
  commonForgotPasswordLazyRoute: typeof commonForgotPasswordLazyRoute
  commonTenantInvitationInvitationTokenLazyRoute: typeof commonTenantInvitationInvitationTokenLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  LayoutRoute: LayoutRouteWithChildren,
  commonLoginRoute: commonLoginRoute,
  commonResetPasswordRoute: commonResetPasswordRoute,
  commonSetUpPasswordRoute: commonSetUpPasswordRoute,
  commonForgotPasswordLazyRoute: commonForgotPasswordLazyRoute,
  commonTenantInvitationInvitationTokenLazyRoute:
    commonTenantInvitationInvitationTokenLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_layout",
        "/(common)/login",
        "/(common)/reset-password",
        "/(common)/set-up-password",
        "/(common)/forgot-password",
        "/(common)/tenant-invitation_/$invitationToken"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/tenant/audit-logs",
        "/_layout/tenant/password",
        "/_layout/site/",
        "/_layout/tenant/",
        "/_layout/tenant/bookings",
        "/_layout/tenant/employees",
        "/_layout/tenant/organization-details",
        "/_layout/tenant/spaces",
        "/_layout/tenant/booking-rules/$bookingRulesToken",
        "/_layout/tenant/booking-rules/create",
        "/_layout/tenant/issues/$issueToken",
        "/_layout/tenant/booking-rules/",
        "/_layout/tenant/issues/",
        "/_layout/tenant/statistics/_layout/"
      ]
    },
    "/(common)/login": {
      "filePath": "(common)/login.tsx"
    },
    "/(common)/reset-password": {
      "filePath": "(common)/reset-password.tsx"
    },
    "/(common)/set-up-password": {
      "filePath": "(common)/set-up-password.tsx"
    },
    "/(common)/forgot-password": {
      "filePath": "(common)/forgot-password.lazy.tsx"
    },
    "/(common)/tenant-invitation_/$invitationToken": {
      "filePath": "(common)/tenant-invitation_/$invitationToken.lazy.tsx"
    },
    "/_layout/tenant/audit-logs": {
      "filePath": "_layout/tenant/audit-logs.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/tenant/password": {
      "filePath": "_layout/tenant/password.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/site/": {
      "filePath": "_layout/site/index.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/tenant/": {
      "filePath": "_layout/tenant/index.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/tenant/bookings": {
      "filePath": "_layout/tenant/bookings",
      "parent": "/_layout",
      "children": [
        "/_layout/tenant/bookings/_layout",
        "/_layout/tenant/bookings/create"
      ]
    },
    "/_layout/tenant/bookings/_layout": {
      "filePath": "_layout/tenant/bookings/_layout.tsx",
      "parent": "/_layout/tenant/bookings",
      "children": [
        "/_layout/tenant/bookings/_layout/"
      ]
    },
    "/_layout/tenant/employees": {
      "filePath": "_layout/tenant/employees",
      "parent": "/_layout",
      "children": [
        "/_layout/tenant/employees/_layout",
        "/_layout/tenant/employees/groups/$groupToken"
      ]
    },
    "/_layout/tenant/employees/_layout": {
      "filePath": "_layout/tenant/employees/_layout.tsx",
      "parent": "/_layout/tenant/employees",
      "children": [
        "/_layout/tenant/employees/_layout/groups",
        "/_layout/tenant/employees/_layout/"
      ]
    },
    "/_layout/tenant/organization-details": {
      "filePath": "_layout/tenant/organization-details",
      "parent": "/_layout",
      "children": [
        "/_layout/tenant/organization-details/_layout"
      ]
    },
    "/_layout/tenant/organization-details/_layout": {
      "filePath": "_layout/tenant/organization-details/_layout.tsx",
      "parent": "/_layout/tenant/organization-details",
      "children": [
        "/_layout/tenant/organization-details/_layout/admins",
        "/_layout/tenant/organization-details/_layout/"
      ]
    },
    "/_layout/tenant/spaces": {
      "filePath": "_layout/tenant/spaces",
      "parent": "/_layout",
      "children": [
        "/_layout/tenant/spaces/_layout",
        "/_layout/tenant/spaces/create",
        "/_layout/tenant/spaces/newer-old-floor-planner",
        "/_layout/tenant/spaces/old-floor-planner",
        "/_layout/tenant/spaces/groups/$spaceGroupToken",
        "/_layout/tenant/spaces/$spaceToken/edit"
      ]
    },
    "/_layout/tenant/spaces/_layout": {
      "filePath": "_layout/tenant/spaces/_layout.tsx",
      "parent": "/_layout/tenant/spaces",
      "children": [
        "/_layout/tenant/spaces/_layout/groups",
        "/_layout/tenant/spaces/_layout/floor-planner",
        "/_layout/tenant/spaces/_layout/"
      ]
    },
    "/_layout/tenant/booking-rules/$bookingRulesToken": {
      "filePath": "_layout/tenant/booking-rules/$bookingRulesToken.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/tenant/booking-rules/create": {
      "filePath": "_layout/tenant/booking-rules/create.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/tenant/bookings/create": {
      "filePath": "_layout/tenant/bookings/create.lazy.tsx",
      "parent": "/_layout/tenant/bookings"
    },
    "/_layout/tenant/issues/$issueToken": {
      "filePath": "_layout/tenant/issues/$issueToken.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/tenant/spaces/create": {
      "filePath": "_layout/tenant/spaces/create.lazy.tsx",
      "parent": "/_layout/tenant/spaces"
    },
    "/_layout/tenant/spaces/newer-old-floor-planner": {
      "filePath": "_layout/tenant/spaces/newer-old-floor-planner.lazy.tsx",
      "parent": "/_layout/tenant/spaces"
    },
    "/_layout/tenant/spaces/old-floor-planner": {
      "filePath": "_layout/tenant/spaces/old-floor-planner.lazy.tsx",
      "parent": "/_layout/tenant/spaces"
    },
    "/_layout/tenant/booking-rules/": {
      "filePath": "_layout/tenant/booking-rules/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/tenant/issues/": {
      "filePath": "_layout/tenant/issues/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/tenant/employees/_layout/groups": {
      "filePath": "_layout/tenant/employees/_layout/groups.tsx",
      "parent": "/_layout/tenant/employees/_layout"
    },
    "/_layout/tenant/organization-details/_layout/admins": {
      "filePath": "_layout/tenant/organization-details/_layout/admins.tsx",
      "parent": "/_layout/tenant/organization-details/_layout"
    },
    "/_layout/tenant/spaces/_layout/groups": {
      "filePath": "_layout/tenant/spaces/_layout/groups.tsx",
      "parent": "/_layout/tenant/spaces/_layout"
    },
    "/_layout/tenant/spaces/groups/$spaceGroupToken": {
      "filePath": "_layout/tenant/spaces/groups/$spaceGroupToken.tsx",
      "parent": "/_layout/tenant/spaces"
    },
    "/_layout/tenant/spaces/$spaceToken/edit": {
      "filePath": "_layout/tenant/spaces/$spaceToken/edit.lazy.tsx",
      "parent": "/_layout/tenant/spaces"
    },
    "/_layout/tenant/spaces/_layout/floor-planner": {
      "filePath": "_layout/tenant/spaces/_layout/floor-planner.lazy.tsx",
      "parent": "/_layout/tenant/spaces/_layout"
    },
    "/_layout/tenant/bookings/_layout/": {
      "filePath": "_layout/tenant/bookings/_layout/index.tsx",
      "parent": "/_layout/tenant/bookings/_layout"
    },
    "/_layout/tenant/employees/_layout/": {
      "filePath": "_layout/tenant/employees/_layout/index.tsx",
      "parent": "/_layout/tenant/employees/_layout"
    },
    "/_layout/tenant/spaces/_layout/": {
      "filePath": "_layout/tenant/spaces/_layout/index.tsx",
      "parent": "/_layout/tenant/spaces/_layout"
    },
    "/_layout/tenant/statistics/_layout/": {
      "filePath": "_layout/tenant/statistics/_layout/index.ts",
      "parent": "/_layout"
    },
    "/_layout/tenant/organization-details/_layout/": {
      "filePath": "_layout/tenant/organization-details/_layout/index.lazy.tsx",
      "parent": "/_layout/tenant/organization-details/_layout"
    },
    "/_layout/tenant/employees/groups/$groupToken": {
      "filePath": "_layout/tenant/employees/groups/$groupToken",
      "parent": "/_layout/tenant/employees",
      "children": [
        "/_layout/tenant/employees/groups/$groupToken/_layout"
      ]
    },
    "/_layout/tenant/employees/groups/$groupToken/_layout": {
      "filePath": "_layout/tenant/employees/groups/$groupToken/_layout.tsx",
      "parent": "/_layout/tenant/employees/groups/$groupToken",
      "children": [
        "/_layout/tenant/employees/groups/$groupToken/_layout/bookings",
        "/_layout/tenant/employees/groups/$groupToken/_layout/employees",
        "/_layout/tenant/employees/groups/$groupToken/_layout/space-groups",
        "/_layout/tenant/employees/groups/$groupToken/_layout/booking-rules"
      ]
    },
    "/_layout/tenant/employees/groups/$groupToken/_layout/bookings": {
      "filePath": "_layout/tenant/employees/groups/$groupToken/_layout/bookings.tsx",
      "parent": "/_layout/tenant/employees/groups/$groupToken/_layout"
    },
    "/_layout/tenant/employees/groups/$groupToken/_layout/employees": {
      "filePath": "_layout/tenant/employees/groups/$groupToken/_layout/employees.tsx",
      "parent": "/_layout/tenant/employees/groups/$groupToken/_layout"
    },
    "/_layout/tenant/employees/groups/$groupToken/_layout/space-groups": {
      "filePath": "_layout/tenant/employees/groups/$groupToken/_layout/space-groups.tsx",
      "parent": "/_layout/tenant/employees/groups/$groupToken/_layout"
    },
    "/_layout/tenant/employees/groups/$groupToken/_layout/booking-rules": {
      "filePath": "_layout/tenant/employees/groups/$groupToken/_layout/booking-rules.lazy.tsx",
      "parent": "/_layout/tenant/employees/groups/$groupToken/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
